
import {
	Component, Vue, Prop,
} from 'vue-property-decorator';

const TEST_ID = 'Kloans-PaymentAmountWidget';

@Component
export default class PaymentAmountWidget extends Vue {
	@Prop({ default: '' })
	public amountCssClass!: string;

	public TEST_ID = TEST_ID;
}
